import Button from '@mui/material/Button';
import { forwardRef, memo } from 'react';

/**
 * @param {import('@mui/material').Theme} theme
 */

const style = (theme) => ({
  display: 'inline',
  backgroundColor: 'transparent',
  textDecoration: 'underline',
  lineHeight: 'inherit',
  color: theme.palette.text.primary,
  fontSize: 'inherit',
  padding: 0,
  verticalAlign: 'baseline',
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: 'transparent',
    textDecoration: 'underline',
    textDecorationColor: theme.palette.primary.main,
  },
});

/**
 * InlineButton component
 * @param {import('@mui/material/Button').ButtonProps} props
 * @param {React.Ref<any>} ref
 * @returns {React.JSX.Element}
 * @constructor
 */
 
const InlineTextButtonComponent = ({ children, sx = {}, ...rest }, ref) => (
  <Button
    disableRipple
    ref={ref}
    size="small"
    sx={(theme) => ({ ...style(theme), ...sx })}
    {...rest}
  >
    {children}
  </Button>
);

InlineTextButtonComponent.displayName = 'InlineButton';

const InlineTextButtonComponentForwardRef = forwardRef(InlineTextButtonComponent);

InlineTextButtonComponentForwardRef.displayName = 'InlineButton';

const InlineTextButton = memo(InlineTextButtonComponentForwardRef);

export default InlineTextButton;
